/* ============================================================
   Pholoh scroll-lock — freeze the page behind any open drawer with a
   plain overflow lock (NO position:fixed, so the page never shifts/jumps).
   Fires for the cart, nav and search drawers (all add `js-drawer-open`;
   the nav drawer also uses `nav-open`).
   ============================================================ */
(function () {
  'use strict';
  var html = document.documentElement;

  function isOpen() {
    return html.classList.contains('js-drawer-open') || html.classList.contains('nav-open');
  }

  function sync() {
    var lock = isOpen();
    // IMPORTANT: only lock <html> (the scroll container). Setting overflow:hidden
    // on <body> reparents the sticky-header context to <body>, which makes the
    // sticky header + announcement bar scroll off-screen when a drawer opens.
    // Never touch <body> overflow.
    html.style.overflow = lock ? 'hidden' : '';
    html.style.overscrollBehavior = lock ? 'none' : '';
  }

  new MutationObserver(sync).observe(html, { attributes: true, attributeFilter: ['class'] });
  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);
})();
